module.exports = __webpack_public_path__ + "site/img/71.daaa2596.jpg";